import { oauth } from 'api/clients';

export const getApplications = () => oauth.get('/api/v1/idm_access/applications');
